import { XbedAPI } from "xbed-api";
import Config from "../config"

export const ERR_TOKEN_INVALID = 41020003;
export const SYSTEM_UP_GRADE= 50000000;

const {isMiniprogram} = window;


const API = new XbedAPI(Config.REACT_APP_DEBUG,{
    gatewayUrl:Config.REACT_APP_GATEWAY_URL,
    edition:isMiniprogram? Config.REACT_APP_MINI_EDITION : Config.REACT_APP_EDITION,
    goods:Config.REACT_APP_GOODS,
    terrace:isMiniprogram? Config.REACT_APP_MINI_TERRACE : Config.REACT_APP_TERRACE,
    xbedSecretKey:Config.REACT_APP_XBED_SECRET_KEY,
    xbedSecretToken:Config.REACT_APP_XBED_SECRET_TOKEN
},{
    request(){},
    response(){}
});

export const ElongAPI = new XbedAPI(Config.REACT_APP_DEBUG,{
    gatewayUrl:Config.REACT_APP_ELONG_GATEWAY_URL,
    edition:isMiniprogram? Config.REACT_APP_MINI_EDITION : Config.REACT_APP_EDITION,
    goods:Config.REACT_APP_GOODS,
    terrace:isMiniprogram? Config.REACT_APP_MINI_TERRACE : Config.REACT_APP_TERRACE,
    xbedSecretKey:Config.REACT_APP_XBED_SECRET_KEY,
    xbedSecretToken:Config.REACT_APP_XBED_SECRET_TOKEN
},{
    request(){},
    response(){}
})

export default API;


// WEBPACK FOOTER //
// ./src/api/index.js